import { createContext, useContext, useState } from "react";

const AppContext = createContext();

export const AppContextProvider = ({ children }) => {
  const [role, setRole] = useState("admin");
  return <AppContext.Provider value={{ role }}>{children}</AppContext.Provider>;
};

export const useStore = () => useContext(AppContext);
